import queryString from 'query-string';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { isEmpty } from 'lodash';
import App from './App';
import { cacheItem } from './util/cache';
import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey(
  '8eba99467d8a15357ecd563b2d07b7c7Tz05MjM2NyxFPTE3NDk4NDA4NTcwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
);

const queryParams = queryString.parse(window.location.search);

if (!isEmpty(queryParams)) {
  const previousConnexId = localStorage.getItem('x-connex-id') || '';

  const connexId = queryParams['x-connex-id'] || previousConnexId;
  const source = queryParams['source'] || localStorage.getItem('source');
  const language = queryParams['language'] || localStorage.getItem('language');
  const themeName = queryParams['theme'] || localStorage.getItem('themeName') || 'dark';
  const entityRef = queryParams['entityRef'] || localStorage.getItem('entityRef');

  cacheItem('source', source || '');
  cacheItem('themeName', themeName);
  cacheItem('language', language || '');
  cacheItem('entityRef', entityRef);

  if (connexId) {
    cacheItem('x-connex-id', connexId);
  }

  // Strip query params off URL
  window.location.href = `${window?.location?.pathname?.[0] !== '/' ? '/' : ''}${window.location.pathname}`;
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
